import React, { createContext, useContext, useState } from 'react'
import PropTypes from 'prop-types'

const CabinClassContext = createContext(null)

export const CabinClassProvider = ({ defaultClass = 'economy', children }) => {
  const [cabinClass, setCabinClass] = useState(defaultClass)
  return (
    <CabinClassContext.Provider value={{ cabinClass, setCabinClass }}>
      {children}
    </CabinClassContext.Provider>
  )
}

CabinClassProvider.propTypes = {
  defaultClass: PropTypes.string,
  children: PropTypes.node,
}

export const useCabinClass = () => useContext(CabinClassContext)
